import { FC, ReactNode } from "react";
import InfoTip from "../ui/InfoTip";

const NoEmailTip: FC<{
  email?: string | null;
  className?: string;
  children?: ReactNode;
}> = ({ email, className, children }) => (
  <span className={className ?? "flex items-center gap-1.5"}>
    {children}
    {!email?.trim() && (
      <InfoTip
        tone="warning"
        text="Pa email: ky operator nuk merr email-et e rezervimeve."
      />
    )}
  </span>
);

export default NoEmailTip;
